import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

const DatalistInput = ({
  label,
  name,
  value,
  listId,
  options,
  onChange,
  displayKey = "label",
  showList,
  inputRef,
  onKeyDown,
}) => {
  return (
    <Form.Group as={Col} xs={6} sm={4} md={3} lg={2} controlId={name}>
      <div className="dropdown-label">{label}</div>
      <Form.Control
        type="text"
        list={showList ? listId : undefined}
        value={value}
        placeholder={` ${label}`}
        onChange={(e) => onChange(name, e.target.value)}
        onKeyDown={onKeyDown}
        autoComplete="off"
        ref={inputRef}
      />
      {showList && (
        <datalist id={listId}>
          {options.map((opt, index) => (
            <option key={index} value={opt[displayKey]}>
              {opt.label}
            </option>
          ))}
        </datalist>
      )}
    </Form.Group>
  );
};

const WagonFilter = ({
  filters,
  stations,
  handleFilterChange,
  onFind,
  onReset,
  loading,
}) => {
  const [localFilters, setLocalFilters] = useState(filters);
  const [showDropdown, setShowDropdown] = useState({
    from_date: false,
    to_date: false,
    station: false,
  });

  const formDateRef = useRef(null);
  const toDateRef = useRef(null);
  const stationRef = useRef(null);
  const findBtnRef = useRef(null);
  const resetBtnRef = useRef(null);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const handleInputChange = (name, value) => {
    setLocalFilters((prev) => ({ ...prev, [name]: value }));
    handleFilterChange(name, value);

    setShowDropdown((prev) => ({
      ...prev,
      [name]: String(value || "").trim().length > 0,
    }));
  };

  const handleStationChange = (name, value) => {
    handleInputChange("station", value);
  };

  const handleKeyDown = (e, nextRef, action) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (typeof action === "function") {
        action();
      }
      nextRef?.current?.focus();
    }
  };
  return (
    <Form className="vendor-advance-filter-form">
      <Row>
        <Form.Group as={Col} xs={6} sm={4} md={3} lg={2}>
          <div className="dropdown-label">From Date</div>
          <Form.Control
            type="date"
            value={localFilters.from_date}
            ref={formDateRef}
            onChange={(e) => handleInputChange("from_date", e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, toDateRef)}
          />
        </Form.Group>
        <Form.Group as={Col} xs={6} sm={4} md={3} lg={2}>
          <div className="dropdown-label">To Date</div>
          <Form.Control
            type="date"
            value={localFilters.to_date}
            ref={toDateRef}
            onChange={(e) => handleInputChange("to_date", e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, stationRef)}
          />
        </Form.Group>
        <Form.Group as={Col} xs={6} sm={4} md={3} lg={2}>
          <div className="dropdown-label">Station</div>
          <Form.Select
            name="station"
            value={localFilters.station}
            onChange={(e) => handleStationChange("station", e.target.value)}
          >
            <option value="">Select Station</option>
            <option value="Thiruvarur">Thiruvarur</option>
            <option value="Mannargudi">Mannargudi</option>
            <option value="Needamangalam">Needamangalam</option>
          </Form.Select>
        </Form.Group>
        {/* <DatalistInput
          label="Station"
          name="station"
          value={localFilters.station}
          listId="stationList"
          options={stations}
          onChange={handleStationChange}
          showList={showDropdown.station}
          inputRef={stationRef}
          onKeyDown={(e) => handleKeyDown(e, findBtnRef)}
        /> */}
        <Col className="d-flex justify-content-end align-items-center">
          <Button
            variant="primary"
            className="me-2"
            onClick={onFind}
            ref={findBtnRef}
            onKeyDown={(e) => handleKeyDown(e, resetBtnRef, onFind)}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Finding..
              </>
            ) : (
              "Find"
            )}
          </Button>
          <Button
            variant="secondary"
            onClick={onReset}
            ref={resetBtnRef}
            onKeyDown={(e) => handleKeyDown(e, null, onReset)}
          >
            Reset
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default WagonFilter;
